module.exports = __webpack_public_path__ + "img/2.f36f59ea.png";